<template>
  <div>
    <div class="spinner-wrapper" v-if="mainSpinner">
      <div class="loader08"></div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    mainSpinner () {
      return this.$root.spinners.main
    }
  },
  watch: {
    'mainSpinner': function (x, y) {
      if (x) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.loader08 {
  width: 20px;
  height: 20px;
  position: relative;
  animation: loader08-ub06eb63b 1s ease infinite;
  top: 50%;
  margin: -46px auto 0; }

@keyframes loader08-ub06eb63b {
  0%, 100% {
    box-shadow: -13px 20px 0 var(--v-primary-base), 13px 20px 0 var(--v-primary-lighten2), 13px 46px 0 var(--v-primary-lighten3), -13px 46px 0 var(--v-primary-lighten3); }
  25% {
    box-shadow: -13px 20px 0 var(--v-primary-lighten3), 13px 20px 0 var(--v-primary-base), 13px 46px 0 var(--v-primary-lighten3), -13px 46px 0 var(--v-primary-lighten3); }
  50% {
    box-shadow: -13px 20px 0 var(--v-primary-lighten3), 13px 20px 0 var(--v-primary-lighten3), 13px 46px 0 var(--v-primary-base), -13px 46px 0 var(--v-primary-lighten4); }
  75% {
    box-shadow: -13px 20px 0 var(--v-primary-lighten2), 13px 20px 0 var(--v-primary-lighten3), 13px 46px 0 var(--v-primary-lighten3), -13px 46px 0 var(--v-primary-base); } }

.spinner-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  background: rgba(168, 168, 168, 0.5);
  height: 100%;
  z-index: 9999;
}
</style>
